

import BasicCard from "../BasicCard"
import Dummylayout from "../Dummylayout";
import IniatiateAppraisalForm from "./IntiatiateAppraisalForm";
function InitiateAppraisalMain(){

    return(
       <>
       <Dummylayout/>
     <BasicCard>
        <IniatiateAppraisalForm/>
     </BasicCard>
     
        
       </>

    )
};
export default InitiateAppraisalMain;
